<template>
    <div class="c-event-filters__dates">
        <div class="c-range-date-filter">
            <label>Date Range</label>
            <div class="c-range-date-filter__inputs">
                <input type="text" value="" name="date-range-start" id="c-date-select--start" class="c-date-control" placeholder="Start date" readonly>
                <input disabled type="text"  value="" class="c-date-control" name="date-range-end" id="c-date-select--end"  placeholder="End date" readonly/>
                <button @click="clearDates" v-if="showCancelButton" class="c-range-date-filter__clear"><i class="far fa-times"></i> Clear dates</button>
            </div>
        </div>
    </div>

</template>

<script>
    import jQuery from 'jquery'
    import moment from 'moment-timezone'
    import "../vendor/date-range-picker"

    export default {
        name: "DateRangeFilter",
        props: ['options'],
        data() {
            return {
                showCancelButton: false,
            }
        },
        mounted() {
            this.setupStartDatePicker()
            this.assignStartDatePickerEvents()
            this.applyUrlParamsToDateFields()
        },
        methods: {
            applyUrlParamsToDateFields() {
                const $startDate = jQuery('#c-date-select--start')
                const $endDate = jQuery('#c-date-select--end')

                const queryString = window.location.search
                const urlParams = new URLSearchParams(queryString)

                if (urlParams.has('start-date')) {
                    this.showCancelButton = true
                    let date = moment(urlParams.get('start-date'))
                    this.updateStartDateState(date.format('YYYY-MM-DD'))
                    $startDate.val(date.format('MMM D, YYYY'))
                    $startDate.data('daterangepicker').setStartDate(date)
                    $startDate.data('daterangepicker').setEndDate(date)


                }

                if (urlParams.has('end-date')) {
                    let date = moment(urlParams.get('end-date'))
                    this.updateEndDateState(date.format('YYYY-MM-DD'))
                    this.setupEndDatePicker(date.format('YYYY-MM-DD'))
                    $endDate.data('daterangepicker').setStartDate(date)
                    $endDate.data('daterangepicker').setEndDate(date)
                    $endDate.val(date.format('MMM D, YYYY'))
                }
            },
            setupStartDatePicker() {
                const $startDate = jQuery('#c-date-select--start')
                $startDate.daterangepicker({
                    singleDatePicker: true,
                    startDate: moment(),
                    endDate: moment(),
                    autoUpdateInput: false,
                    autoApply: true,
                    minDate: moment(),
                    locale: {
                        format: 'MMM D, YYYY',
                        cancelLabel: 'Clear',
                        firstDay: 0,
                    },
                });

            },
            setupEndDatePicker() {
                const $endDate = jQuery('#c-date-select--end')
                const currentSetStartDate = moment(this.$store.getters.startDate)
                const currentSetEndDate = moment(this.$store.getters.endDate)

                if (currentSetStartDate.isSameOrAfter(currentSetEndDate)) {
                    this.updateEndDateState(this.$store.getters.startDate)
                }
                $endDate.removeAttr('disabled')

                $endDate.daterangepicker({
                    singleDatePicker: true,
                    autoUpdateInput: true,
                    autoApply: true,
                    startDate: currentSetStartDate,
                    endDate: currentSetStartDate,
                    minDate: currentSetStartDate,
                    locale: {
                        format: 'MMM D, YYYY',
                        cancelLabel: 'Clear',
                        firstDay: 0,
                    },
                });
                this.assignEndDatePickerEvents()


            },
            assignStartDatePickerEvents() {
                const $startDate = jQuery('#c-date-select--start')
                const $endDate = jQuery('#c-date-select--end')

                $startDate.on('apply.daterangepicker', (ev, picker) => {
                    this.showCancelButton = true
                    const selectedStartDate = picker.startDate
                    jQuery(ev.currentTarget).val(selectedStartDate.format('MMM D, YYYY'))
                    if ($endDate.val() === '') {
                        $endDate.val(selectedStartDate.format('MMM D, YYYY'))
                        this.updateEndDateState(selectedStartDate.format('YYYY-MM-DD'))
                    }

                    this.updateStartDateState(selectedStartDate.format('YYYY-MM-DD'))
                    this.setupEndDatePicker()

                });

                $startDate.on('cancel.daterangepicker', (ev, picker) => {
                    jQuery(ev.currentTarget).val();
                    jQuery(ev.currentTarget).data('daterangepicker').setStartDate(moment())
                    this.updateStartDateState(null)
                });

            },
            assignEndDatePickerEvents() {
                const $endDate = jQuery('#c-date-select--end')
                $endDate.on('apply.daterangepicker', (ev, picker) => {
                    const selectedEndDate = picker.endDate
                    jQuery(ev.currentTarget).val(selectedEndDate.format('MMM D, YYYY'));
                    this.updateEndDateState(selectedEndDate.format('YYYY-MM-DD'))
                });

                $endDate.on('cancel.daterangepicker', (ev, picker) => {
                    jQuery(ev.currentTarget).val();
                    jQuery(ev.currentTarget).attr('disabled', true)
                    this.updateEndDateState(null)
                });

            },
            clearDates() {
                const $startDate = jQuery('#c-date-select--start')
                const $endDate = jQuery('#c-date-select--end')
                // clear input fields an dreset start date of start date picker
                $startDate.val('')
                $startDate.data('daterangepicker').setStartDate(moment())
                $startDate.data('daterangepicker').setEndDate(moment())

                // clear the input field value and disable end date filter
                $endDate.val('');
                $endDate.attr('disabled', true)

                // set state of the dates in vuex to null
                this.updateStartDateState(null)
                this.updateEndDateState(null)

                //hide the cancel button
                this.showCancelButton = false
            },
            updateStartDateState(date) {
                // Updates values in single datepicker in the VueX store found in src/vue/store/state.js
                this.$store.commit('updateField', {
                    name: 'start-date',
                    value: date
                })
            },
            updateEndDateState(date) {
                // Updates values in single datepicker in the VueX store found in src/vue/store/state.js
                this.$store.commit('updateField', {
                    name: 'end-date',
                    value: date
                })
            }

        }
    }
</script>

<style scoped>

</style>
